<template>
  <div class="title-container">
    <template v-if="isBreadcrumbs">
      <div
        class="current-page"
        @click="showPreCrumbs = !showPreCrumbs"
      >
        <h1>{{ activeCrumb }}</h1>
      </div>
    </template>
    <template v-else>
      <h1 class="welcome">
        {{ breadcrumbs }}
      </h1>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GetterTypes from '@/store/constants/getters';

export default {
  name: 'HeaderTitle',
  data() {
    return {
      showPreCrumbs: false,
    };
  },
  computed: {
    ...mapGetters([
      GetterTypes.BREADCRUMBS,
    ]),
    isBreadcrumbs() {
      return Array.isArray(this.breadcrumbs);
    },
    activeCrumb() {
      return this.breadcrumbs[this.breadcrumbs.length - 1].name;
    },
  },
};
</script>

<style lang="scss" scoped>
  .title-container {
    display: flex;
    align-items: center;
    height: calc(100% - 1px);
    position: relative;
    font-weight: 500;
    font-size: 12px;
    border-bottom: 1px solid var(--primary-divider-hex);
    color: var(--accent-text-alt-color-hex);
  }
</style>
